import { mediaPhone } from "./breakpoints";

/** A focused field that opens the on-screen keyboard (not checkboxes, buttons or read-only selects). */
export const TEXT_FIELD_FOCUSED = [
	'input:not([type="checkbox"], [type="radio"], [type="range"], [type="button"], [type="submit"], [type="reset"], [type="file"], [type="color"], [readonly]):focus',
	"textarea:not([readonly]):focus",
	'[contenteditable="true"]:focus',
].join(", ");

/** Set on <html> by `trackKeyboard` while the on-screen keyboard is up. */
export const KEYBOARD_OPEN_ATTRIBUTE = "data-keyboard-open";

/**
 * Phones: hides a bar pinned to the bottom of the screen while the on-screen keyboard is up. The viewport
 * resizes for the keyboard (interactive-widget=resizes-content), which would otherwise lift the bar above
 * the keyboard on Android. It returns when the keyboard closes, even if the field keeps focus. The attribute
 * is on <html>, so this also covers fields in drawers and modals, which render outside the layout.
 *
 * Apply it to the bar itself, or pass a selector to hide a part of it (for example antd's
 * `.ant-modal-footer` inside a sheet). Never use it on a bar that contains the focused field.
 */
export const hideWhileTyping = (descendant = "") => mediaPhone`
	html[${KEYBOARD_OPEN_ATTRIBUTE}] &${descendant ? ` ${descendant}` : ""} {
		display: none;
	}
`;
